import { useContext } from 'react';

import { ctxUser } from '@/contexts/UserContext';

export function useCurrentUser() {
  return useContext(ctxUser);
}
